import type { PositionPath } from './soccerPositionPaths';

export const baseballPositionPaths: PositionPath[] = [
  {
    id: 'pos-pitcher',
    position: 'Pitcher',
    emoji: '🥎',
    shortDescription: 'Sets the tempo',
    description: 'Master pitch counts, sequencing, and the art of attacking hitters.',
    lessonIds: [
      'baseball-the-diamond',
      'baseball-battery',
      'baseball-balls-vs-strikes',
      'baseball-strike-zone',
      'baseball-how-pitch-counts-work',
      'baseball-pitch-types',
    ],
    lessonRelevance: {
      'baseball-the-diamond': 'Know where every fielder is so you can pitch to contact with confidence.',
      'baseball-battery': 'Your relationship with the catcher is the heartbeat of every outing.',
      'baseball-balls-vs-strikes': 'Owning the count is owning the at-bat.',
      'baseball-strike-zone': 'Hitting corners is what separates good pitchers from great ones.',
      'baseball-how-pitch-counts-work': 'Manage your workload so your best stuff is there in the late innings.',
      'baseball-pitch-types': 'Sequence is everything — fastball/off-speed/breaking variety wins.',
    },
  },
  {
    id: 'pos-catcher',
    position: 'Catcher',
    emoji: '🧤',
    shortDescription: 'On-field defensive coordinator',
    description: 'Call pitches, frame strikes, and run the defense from behind the plate.',
    lessonIds: [
      'baseball-battery',
      'baseball-strike-zone',
      'baseball-balls-vs-strikes',
      'baseball-pitch-types',
      'baseball-double-play',
    ],
    lessonRelevance: {
      'baseball-battery': 'You ARE the battery captain — call the game.',
      'baseball-strike-zone': 'Frame the corners and steal extra strikes for your pitcher.',
      'baseball-balls-vs-strikes': 'Set up sequences that work the count in your favor.',
      'baseball-pitch-types': 'Know every pitch in your pitcher\'s arsenal and when to call it.',
      'baseball-double-play': 'Set up the infield to maximize the chance of two outs.',
    },
  },
  {
    id: 'pos-infielder',
    position: 'Infielder',
    emoji: '⚙️',
    shortDescription: 'Quick hands, quicker reads',
    description: 'Learn positioning, double-play turns, and reading the hitter pre-pitch.',
    lessonIds: [
      'baseball-the-diamond',
      'baseball-double-play',
      'baseball-defensive-shifts',
      'baseball-base-running-basics',
      'baseball-hit-and-run',
    ],
    lessonRelevance: {
      'baseball-the-diamond': 'Know your zone and your relays cold.',
      'baseball-double-play': 'The 6-4-3 and 4-6-3 turns are infielder fundamentals.',
      'baseball-defensive-shifts': 'Position based on hitter tendencies, not habit.',
      'baseball-base-running-basics': 'Anticipate the runner\'s read so you can beat it.',
      'baseball-hit-and-run': 'Recognize hit-and-run counts and adjust coverage.',
    },
  },
  {
    id: 'pos-outfielder',
    position: 'Outfielder',
    emoji: '🚀',
    shortDescription: 'Range and arm',
    description: 'Cover ground, hit cut-offs, and turn doubles into outs.',
    lessonIds: [
      'baseball-the-diamond',
      'baseball-base-running-basics',
      'baseball-defensive-shifts',
      'baseball-double-play',
    ],
    lessonRelevance: {
      'baseball-the-diamond': 'Read where the ball is going off the bat and run the right route.',
      'baseball-base-running-basics': 'Anticipate the runner\'s tag-up and take charge of throws.',
      'baseball-defensive-shifts': 'Outfield depth and shading are part of the shift game too.',
      'baseball-double-play': 'A great throw to the cut-off can become an unexpected double play.',
    },
  },
  {
    id: 'pos-hitter',
    position: 'Hitter',
    emoji: '🏏',
    shortDescription: 'Plate discipline + power',
    description: 'Build a swing, work the count, and hit your pitch.',
    lessonIds: [
      'baseball-balls-vs-strikes',
      'baseball-strike-zone',
      'baseball-stance-grip',
      'baseball-plate-discipline',
      'baseball-base-running-basics',
      'baseball-era-stats',
    ],
    lessonRelevance: {
      'baseball-balls-vs-strikes': 'Hitter\'s counts vs pitcher\'s counts change everything.',
      'baseball-strike-zone': 'Knowing the zone is the foundation of plate discipline.',
      'baseball-stance-grip': 'A balanced setup gives you a chance against every pitch.',
      'baseball-plate-discipline': 'Take balls. Hammer strikes. The math is in your favor.',
      'baseball-base-running-basics': 'After you hit, you become a runner — read the play.',
      'baseball-era-stats': 'Understand how your at-bats show up in the numbers.',
    },
  },
];
